/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Paper } from '@mui/material';
import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS } from 'styles/theme';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import React from 'react';
import classNames from 'classnames';
import ReportDetailsCard from './reportDetailsCard.component';

import { TRANSFEREE_PAYEE_TYPE } from './expenseDetailsView.container';
import DynamicFilePreviewCard from 'modules/expenses/common/dynamicFilePreviewCard.component';
import InfoBox from 'modules/expenses/common/infoBox.component';
import RepayAgreementInfoBox from 'modules/expenses/common/repayAgreementInfoBox.component';

const styles = theme => ({
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED_XS}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`
    }
  },
  headerFixed: {
    zIndex: 4
  },
  estimateHeaderFixed: {
    paddingTop: '115px',
    zIndex: 2
  }
});

const ExpenseDetails = props => {
  const {
    authDetails,
    enumerations,
    expenseDetail,
    authId,
    clientRelocationPolicies,
    expenseId,
    expenseCodes,
    onCreateExpense,
    onUpdateExpense,
    onDeleteExpense,
    buildExpenseDetailDto,
    history,
    location,
    match,
    onSaveLineItem,
    onDeleteLineItem,
    setExceptions,
    onBulkUpdateStatus,
    onCopyLineItem,
    updateParentExpenseAttachments,
    updateParentExpenseLineAttachments,
    exceptionSummaries,
    pushExpenseToAcumaticaFunc
  } = props;

  const transferee = authDetails ? authDetails?.familyMembers.find(s => s.familyRelationshipTypeId === TRANSFEREE_PAYEE_TYPE) : null;
  const expenseInfo = expenseDetail ? expenseDetail.expenseInformation : null;
  const expenseStatus = expenseInfo ? (expenseInfo.isExpenseApproved ? 'Approved' : 'Submitted') : '';

  return (
    <Box>
      <Paper square className={classNames('position-fixed', props.classes.headerFixed, props.classes.container, { [props.classes.drawerOpen]: true })} sx={{ position: 'relative', width: '100%' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', width: '100%' }}>
          <Box sx={{ paddingLeft: '100px' }}>&nbsp;</Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', flexGrow: 1 }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '10px' }}>
                <InfoBox label="Authorization Name" value={`${transferee?.firstName ?? 'N/a'} ${transferee?.lastName ?? ''}`} />
                <InfoBox label="Policy" value={'Policy'} />
                <InfoBox label="Status" value={expenseStatus} />
                <InfoBox label="Move Cap" value="$5,000" />
                <InfoBox label="Budget Remaining" value="$4,999" />
              </Box>
            </Box>
          </Box>
          <Box sx={{ paddingTop: '10px' }}>
            <RepayAgreementInfoBox authorizationDetails={authDetails?.authorizationDetails} clientRelocationPolicies={clientRelocationPolicies} />
          </Box>
        </Box>
      </Paper>
      <Box sx={{ margin: '16px', marginTop: '0px' }}>
        <ReportDetailsCard
          expenseDetail={expenseDetail}
          authId={authId}
          expenseCodes={expenseCodes}
          onCreateExpense={onCreateExpense}
          onUpdateExpense={onUpdateExpense}
          onDeleteExpense={onDeleteExpense}
          onSaveLineItem={onSaveLineItem}
          onDeleteLineItem={onDeleteLineItem}
          buildExpenseDetailDto={buildExpenseDetailDto}
          history={history}
          location={location}
          match={match}
          enumerations={enumerations}
          expenseId={expenseId}
          authDetails={authDetails}
          onBulkUpdateStatus={onBulkUpdateStatus}
          onCopyLineItem={onCopyLineItem}
          updateParentExpenseAttachments={updateParentExpenseAttachments}
          updateParentExpenseLineAttachments={updateParentExpenseLineAttachments}
          exceptionSummaries={exceptionSummaries}
          setExceptions={setExceptions}
          pushExpenseToAcumaticaFunc={pushExpenseToAcumaticaFunc}
        />
      </Box>
      <Box sx={{ padding: '16px', marginTop: '0px' }}>
        <DynamicFilePreviewCard authId={authId} history={history} location={location} isReadOnly={true} />
      </Box>
    </Box>
  );
};

const mapStateToProps = state => ({});

export default compose(withStyles(styles), connect(mapStateToProps, {}))(ExpenseDetails);
